import {Model} from './model';
import {Unserializer} from './serialization';

export class NotificationLog implements Model {
  notificationLogId: number;
  invoiceId: number;
  userId?: number;
  notification: boolean;
  changed: Date;

  static copy(oldObj: NotificationLog): NotificationLog {
    const newObj = new NotificationLog();
    newObj.notificationLogId = oldObj.notificationLogId;
    newObj.invoiceId = oldObj.invoiceId;
    newObj.userId = oldObj.userId;
    newObj.notification = oldObj.notification;
    newObj.changed = Unserializer.date(oldObj.changed);
    return newObj;
  }

  static resolveLabel(notification: boolean): string {
    return notification ? 'Payment Reminder' : 'Debt Collection';
  }

  getLabel(): string {
    return NotificationLog.resolveLabel(this.notification);
  }

  public getPrimaryKey(): number {
    return this.notificationLogId;
  }

  isNew(): boolean {
    return isNaN(this.notificationLogId);
  }

  clone(): NotificationLog {
    return NotificationLog.copy(this);
  }
}
